import BaseView from './BaseView';
import barba from '@barba/core';
import ImageCarousel from "../../modules/ImageCarousel";
import EditorialPreheader from '../../components/EditorialPreheader';
import EditorialRelatedEditorials from '../../components/EditorialRelatedEditorials';
import VideoPlayer from "../../modules/VideoPlayer";
import ModuleText from "../../modules/ModuleText";

let view = null;

class Editorial extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const groups = new Map([
			[EditorialPreheader, this.container.querySelectorAll('[data-editorial-preheader]')],
			[ImageCarousel, this.container.querySelectorAll('[data-image-carousel]')],
			[EditorialRelatedEditorials, this.container.querySelectorAll('[data-related-editorials]')],
			[VideoPlayer, this.container.querySelectorAll('[data-video-player]')],
			[ModuleText, this.container.querySelectorAll('[data-m-text]')],
		]);

		super.createModules(groups);

		this.content = this.container.querySelector('[data-editorial-content]');
		const code = this.content.dataset.code;
        barba.logoLayerDirector.newCode(code);
	}

	destroy() {
		//
	}
}

export default {
	namespace: 'single-editorial',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Editorial(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
